// extracted by mini-css-extract-plugin
module.exports = {"root":"button-panel_root__2KAcV"};